/* eslint-disable no-nested-ternary */
// @flow
import React, { useState } from 'react';
import cx from 'classnames';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import LinkBox from './LinkBoxMobile';
import Logo from '../../images/logo-color.svg';
import * as styles from './HeaderMobile.module.scss';
import { merchantMenu } from './const';

const HeaderMerchant = ({
  siteTitle,
  pathname,
  hasNoHeaderNav,
  headerAlpha,
}: {
  siteTitle: string,
  pathname: string,
  hasNoHeaderNav: boolean,
  headerAlpha: number,
}) => {
  const [isHeaderNavActive, setIsHeaderNavActive] = useState(false);

  const onClick = () => {
    setIsHeaderNavActive(false);
  };

  return (
    <div className={cx(styles.headerWrapper)}>
      <header
        className={cx(styles.header, { [styles.isActive]: isHeaderNavActive })}
        style={{
          background: `rgba(255, 255, 255, ${headerAlpha})`,
        }}
      >
        <div className={styles.topBlock}>
          <a href="/" className={styles.logo} onClick={onClick}>
            <img alt={siteTitle} src={Logo} height="32" width="61" loading="lazy" />
          </a>
          <button
            className={cx(styles.menu, 'a11y')}
            onClick={() => setIsHeaderNavActive(!isHeaderNavActive)}
          >
            Menu
          </button>
          {!hasNoHeaderNav && (
            <a
              className={cx(styles.btnLogin, {
                [styles.active]: pathname.endsWith('/merchant/contact_us/'),
              })}
              href="/merchant/contact_us/"
              onClick={onClick}
            >
              導入相談する
            </a>
          )}
        </div>
        {isHeaderNavActive && (
          <nav className={styles.mainNav}>
            {merchantMenu.map(menuItem =>
              menuItem.subMenu ? (
                <LinkBox
                  to={menuItem.link}
                  text={menuItem.title}
                  key={menuItem.title}
                  activeSubMenu={pathname ? pathname.startsWith(menuItem.link) : false}
                >
                  <nav>
                    {menuItem.subMenu.map(subMenuItem =>
                      subMenuItem.link ? (
                        <a
                          href={subMenuItem.link}
                          onClick={onClick}
                          className={cx(pathname.endsWith(subMenuItem.link) ? styles.active : '')}
                          key={subMenuItem.title}
                        >
                          {subMenuItem.title}
                        </a>
                      ) : (
                        <OutboundLink
                          key={subMenuItem.extLink}
                          href={subMenuItem.extLink}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {subMenuItem.title}
                        </OutboundLink>
                      )
                    )}
                  </nav>
                </LinkBox>
              ) : menuItem.link ? (
                <a
                  className={cx({
                    [styles.active]:
                      pathname.endsWith(menuItem.link) || pathname.startsWith(menuItem.followLink),
                  })}
                  href={menuItem.link}
                  onClick={onClick}
                  key={menuItem.title}
                >
                  {menuItem.title}
                </a>
              ) : (
                <div className={styles.linkBox} key={menuItem.extLink}>
                  <OutboundLink href={menuItem.extLink} rel="noopener noreferrer" target="_blank">
                    {menuItem.title}
                  </OutboundLink>
                </div>
              )
            )}
          </nav>
        )}
      </header>
    </div>
  );
};

HeaderMerchant.defaultProps = {
  siteTitle: ``,
  hasNoHeaderNav: false,
  headerAlpha: 1,
};

export default HeaderMerchant;
